import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import * as Types from './purchasePlus_graphql'

export const GetUserOrganisationsDocument = gql`
  query GetUserOrganisations(
    $userId: Int!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: OrganisationsQueryFiltersInput
    $organisationSwitcherScope: Boolean
  ) {
    user(id: $userId) {
      id
      organisations(
        after: $after
        before: $before
        first: $first
        last: $last
        filters: $filters
        organisationSwitcherScope: $organisationSwitcherScope
      ) {
        edges {
          node {
            id
            name
            isASupplier
            isAPurchaser
            legalEntity
            isVerified
            parent {
              id
              name
            }
            createdAt
            owner {
              id
              name
            }
            children {
              totalCount
            }
          }
        }
        pageInfo {
          ...PurchasePlusPageInfo
        }
      }
    }
  }
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<Types.GetUserOrganisationsQuery, Types.GetUserOrganisationsQueryVariables>
